import TagDocumentBanner from './TagDocumentBanner.component';

export default TagDocumentBanner;